/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ConstantTraceType {
  TraceTypeOrderItem = "order_item",
  TraceTypeTask = "task",
  TraceTypeStrip = "strip",
  TraceTypeCatalog = "catalog",
  TraceTypeDelivery = "delivery",
}

export enum ConstantTraceStatus {
  TraceStatusDelivered = "DELIVERED",
  TraceStatusDraft = "DRAFT",
  TraceStatusCreated = "CREATED",
  TraceStatusPending = "PENDING",
  TraceStatusScheduled = "SCHEDULED",
  TraceStatusActive = "ACTIVE",
  TraceStatusFailed = "FAILED",
  TraceStatusPartiallyFulfilled = "PARTIALLY_FULFILLED",
  TraceStatusFulfilled = "FULFILLED",
  TraceStatusInProgress = "IN_PROGRESS",
  TraceStatusUnspecified = "UNSPECIFIED",
  TraceStatusCancelled = "CANCELLED",
  TraceStatusExpired = "EXPIRED",
  TraceStatusRequested = "REQUESTED",
}

export enum ConstantTaskType {
  TaskTypeArchive = "ARCHIVE",
  TaskTypeTasking = "TASKING",
}

export enum ConstantTaskResponseStatus {
  TaskResponseStatusDraft = "DRAFT",
  TaskResponseStatusSubmitted = "SUBMITTED",
  TaskResponseStatusInProgress = "IN_PROGRESS",
  TaskResponseStatusFulfilled = "FULFILLED",
  TaskResponseStatusPartiallyFulfilled = "PARTIALLY_FULFILLED",
  TaskResponseStatusFailed = "FAILED",
  TaskResponseStatusCancelled = "CANCELLED",
}

export enum ConstantStripStatus {
  StripStatusUnspecified = "UNSPECIFIED",
  StripStatusPending = "PENDING",
  StripStatusScheduled = "SCHEDULED",
  StripStatusCaptured = "CAPTURED",
  StripStatusCatalogued = "CATALOGUED",
  StripStatusFailed = "FAILED",
}

export enum ConstantSortingOrder {
  AscendingSortingOrder = "ASC",
  DescendingSortingOrder = "DESC",
}

export enum ConstantSLAParameter {
  SLAParameterBasePrice = "BASE_PRICE",
  SLAParameterLicenseType = "LICENSE_TYPE",
  SLAParameterArchiveTime = "ARCHIVE_TIME",
  SLAParameterTaskingType = "TASKING_TYPE",
  SLAParameterCloudCover = "CLOUD_COVER",
  SLAParameterOffNadir = "OFF_NADIR",
  SLAParameterDeliverySpeed = "DELIVERY_SPEED",
  SLAParameterExclusivity = "EXCLUSIVITY",
  SLAParameterMinAoiSize = "MIN_AOI_SIZE",
  SLAParameterBandset = "BANDSET",
}

export enum ConstantRefundType {
  RefundTypeCancelled = "CANCELLED",
  RefundTypeEdited = "EDITED",
  RefundTypeSLABreached = "SLA_BREACHED",
  RefundTypeFailed = "FAILED",
  RefundTypePartiallyFulfilled = "PARTIALLY_FULFILLED",
  RefundTypeOthers = "OTHERS",
}

export enum ConstantProductType {
  ProductTypeL1C = "L1C",
  ProductTypeL2A = "L2A",
  ProductTypeL1CL2A = "L1C+L2A",
}

export enum ConstantOrganizationType {
  OrganizationTypeCommercialSingleEntity = "commercial_single_entity",
  OrganizationTypeCommercialMultiEntity = "commercial_multi_entity",
  OrganizationTypeGovernmentStateFed = "government_state_fed",
  OrganizationTypeGovernmentCivil = "government_civil",
  OrganizationTypeGovernmentAllGov = "government_all_gov",
  OrganizationTypeGovernmentPublicAccess = "government_public_access",
  OrganizationTypeNonCommercialFreeTrial = "non_commercial_free_trial",
  OrganizationTypeNonCommercialAcademicEnterprise = "non_commercial_academic_enterprise",
  OrganizationTypeNonCommercialAcademicTrial = "non_commercial_academic_trial",
  OrganizationTypeNotAvailable = "",
}

export enum ConstantOrganizationAdoption {
  OrganizationAdoptionEarly = "early",
  OrganizationAdoptionEarlyBinding = "early_binding",
  OrganizationAdoptionNonEarly = "non_early",
}

export enum ConstantOrderStatus {
  OrderStatusPaid = "PAID",
  OrderStatusRefund = "REFUND",
  OrderStatusUnpaid = "UNPAID",
  OrderStatusPaymentInProgress = "PAYMENT_IN_PROGRESS",
}

export enum ConstantOrderItemType {
  OrderItemTypeTasking = "TASKING",
  OrderItemTypeArchive = "ARCHIVE",
  OrderItemTypeRecurring = "RECURRING",
}

export enum ConstantOrderItemStatus {
  OrderItemStatusDraft = "DRAFT",
  OrderItemStatusActive = "ACTIVE",
  OrderItemStatusFulfilled = "FULFILLED",
  OrderItemStatusCancelled = "CANCELLED",
  OrderItemStatusFailed = "FAILED",
  OrderItemStatusPartiallyFulfilled = "PARTIALLY_FULFILLED",
}

export enum ConstantOrderItemRecurrenceUIStatus {
  OrderItemRecurrenceUIStatusEndDate = "END_DATE",
  OrderItemRecurrenceUIStatusNoOfOccurrences = "NO_OF_OCCURRENCES",
  OrderItemRecurrenceUIStatusMaxInterval = "MAX_INTERVAL",
  OrderItemRecurrenceUIStatusNotApplicable = "NOT_APPLICABLE",
}

export enum ConstantOrderItemRecurrence {
  OrderItemRecurrenceOnce = "ONCE",
  OrderItemRecurrenceWeekly = "WEEKLY",
  OrderItemRecurrenceBiweekly = "BIWEEKLY",
  OrderItemRecurrenceMonthly = "MONTHLY",
  OrderItemRecurrenceBimonthly = "BIMONTHLY",
  OrderItemRecurrenceQuarterly = "QUARTERLY",
  OrderItemRecurrenceNotApplicable = "NOT_APPLICABLE",
}

export enum ConstantOrderItemPaymentStatus {
  OrderItemPaymentStatusPaid = "PAID",
  OrderItemPaymentStatusPartialRefund = "PARTIAL-REFUND",
  OrderItemPaymentStatusRefund = "REFUND",
  OrderItemPaymentStatusUnpaid = "UNPAID",
  OrderItemPaymentStatusPartialMonthly = "PARTIAL-MONTHLY",
}

export enum ConstantOrderItemPaymentMode {
  OrderItemPaymentModeFull = "FULL",
  OrderItemPaymentModeMonthly = "MONTHLY",
}

export enum ConstantOrderItemImageType {
  OrderItemImageTypeVNIR = "VNIR",
  OrderItemImageTypeSWIR = "SWIR",
  OrderItemImageTypeVSWIR = "VSWIR",
}

export enum ConstantOrderItemFeasibilityStatus {
  OrderItemFeasibilityStatusNotApplicable = "NOT_APPLICABLE",
  OrderItemFeasibilityStatusFailed = "FAILED",
  OrderItemFeasibilityStatusWeakSuccess = "WEAK_SUCCESS",
  OrderItemFeasibilityStatusSuccess = "SUCCESS",
  OrderItemFeasibilityStatusUnspecified = "UNSPECIFIED",
  OrderItemFeasibilityStatusPending = "PENDING",
}

export enum ConstantOrderItemDeliverySpeed {
  OrderItemDeliverySpeedStandard = "STANDARD",
  OrderItemDeliverySpeedExpedited = "EXPEDITED",
  OrderItemDeliverySpeedNotApplicable = "NOT_APPLICABLE",
}

export enum ConstantOrderItemCaptureSpeed {
  OrderItemCaptureSpeedRegular = "REGULAR",
  OrderItemCaptureSpeedFlexible = "FLEXIBLE",
  OrderItemCaptureSpeedExpedited = "EXPEDITED",
  OrderItemCaptureSpeedCritical = "CRITICAL",
  OrderItemCaptureSpeedAssured = "ASSURED",
  OrderItemCaptureSpeedNotApplicable = "NOT_APPLICABLE",
}

export enum ConstantErrorMetadataType {
  ErrorMetadataTypeFeasibilityCheckFailed = "feasibility_check_failed",
  ErrorMetadataTypeTokensInsufficient = "tokens_insufficient",
  ErrorMetadataTypeRefundFailed = "refund_failed",
  ErrorMetadataTypeFeasibilityCheckFailedWithBadRequest = "feasibility_check_failed_with_bad_request",
}

export enum ConstantDownloadStatus {
  DownloadStatusSuccess = "success",
  DownloadStatusCreated = "created",
  DownloadStatusFailed = "failed",
  DownloadStatusInProgress = "in_progress",
}

export enum ConstantDeliveryStatus {
  DeliveryStatusUnspecified = "UNSPECIFIED",
  DeliveryStatusCreated = "CREATED",
  DeliveryStatusFailed = "FAILED",
  DeliveryStatusInProgress = "IN_PROGRESS",
  DeliveryStatusSuccess = "SUCCESS",
}

export enum ConstantCatalogType {
  CatalogTypeArchive = "ARCHIVE",
  CatalogTypeTasking = "TASKING",
}

export interface ApiError {
  code?: string;
  details?: any;
  message?: string;
}

export interface ApiErrorResponse {
  error?: ApiError;
}

export interface ApiPaginationResponse {
  limit?: number;
  offset?: number;
  total_count?: number;
}

export interface AuditlogActivity {
  id?: string;
  metadata?: AuditlogActivityMetadata;
  resource_id?: string;
  resource_type?: string;
  timestamp?: string;
  type?: string;
  user_id?: string;
}

export interface AuditlogActivityMetadata {
  /** Field change tracking */
  changes?: AuditlogFieldChange[];
  /** Contextual/reference fields */
  task_id?: string;
  tokens_refunded?: number;
  /** Numeric data */
  tokens_used?: number;
  transaction_id?: string;
}

export interface AuditlogFieldChange {
  /** "string", "int", "bool", "time", etc. */
  data_type?: string;
  field?: string;
  new_value?: any;
  old_value?: any;
}

export interface AuditlogReadListResponse {
  logs?: AuditlogActivity[];
}

export interface BandsetReadListResponse {
  bandsets?: BandsetReadResponse[];
}

export interface BandsetReadResponse {
  bands?: GithubComPixxelhqClerkApiBandsetBand[];
  /** @example 1 */
  captures?: number;
  /** @example "" */
  created_at?: string;
  /** @example "" */
  created_by?: string;
  /** @example "Agriculture bandset" */
  description?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "Agriculture" */
  name?: string;
  /** @example "" */
  updated_at?: string;
  /** @example "" */
  updated_by?: string;
}

export interface BandsetRequest {
  bands: GithubComPixxelhqClerkApiBandsetBand[];
  /** @example 1 */
  captures: number;
  /** @example "Agriculture bandset" */
  description: string;
  /** @example "Agriculture" */
  name: string;
}

export interface CatalogCatalogRequest {
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  image_id: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  org_id: string;
}

export interface CatalogCreateCatalogRequest {
  catalogs?: CatalogCatalogRequest[];
}

export interface CatalogDownloadRequest {
  /** @uniqueItems true */
  catalog_ids: string[];
  /** @uniqueItems true */
  order_item_ids: string[];
}

export interface CatalogDownloadResponse {
  download_id?: string;
  signed_url?: string;
  status?: ConstantDownloadStatus;
}

export interface CatalogPermissionFilter {
  image_id: string[];
  org_id: string;
}

export interface CatalogReadListResponse {
  catalogs?: CatalogReadResponse[];
  pagination?: ApiPaginationResponse;
}

export interface CatalogReadResponse {
  /** @example 100 */
  area?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92277" */
  bandset_id?: string;
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "SUCCESSFUL" */
  delivery_status?: ConstantDeliveryStatus;
  details?: CosmosItem;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  image_id?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  order_item_id?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  org_id?: string;
  /** @example 10 */
  overlap?: number;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  task_id?: string;
  /** @example "ARCHIVE" */
  type?: ConstantCatalogType;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
}

export interface CosmosAsset {
  "eo:bands"?: CosmosEoBand[];
  href?: string;
  roles?: string[];
  title?: string;
  type?: string;
}

export interface CosmosEoBand {
  center_wavelength?: number;
  common_name?: string;
  fwhm?: number;
  name?: string;
}

export interface CosmosGeometry {
  coordinates?: number[][][];
  type?: string;
}

export interface CosmosItem {
  assets?: Record<string, CosmosAsset>;
  bbox?: number[];
  collection?: string;
  geometry?: CosmosGeometry;
  id?: string;
  links?: CosmosLink[];
  properties?: CosmosProperties;
  stac_extensions?: any[];
  stac_version?: string;
  type?: string;
}

export interface CosmosLink {
  href?: string;
  rel?: string;
  title?: string;
  type?: string;
}

export interface CosmosProperties {
  constellation?: string;
  created?: string;
  datetime?: string;
  "eo:cloud_cover"?: number;
  gsd?: number;
  instruments?: string[];
  platform?: string;
  "proj:epsg"?: number;
  "proj:shape"?: number[];
  "proj:transform"?: number[];
  "proj:wkt2"?: string;
  "sat:orbit_state"?: string;
  "sat:relative_orbit"?: number;
  "sci:doi"?: string;
  updated?: string;
  "view:off_nadir"?: number;
  "view:satellite_look_angle"?: number;
  "view:sun_azimuth"?: number;
  "view:sun_elevation"?: number;
}

export interface DeliveryCloudDeliveryResponse {
  /** @example "config" */
  config?: string;
  /** @example "path" */
  path?: string;
}

export interface DeliveryCloudInfoRequest {
  config: string;
  path?: string;
}

export interface DeliveryCreateDeliveryRequest {
  deliveries: DeliveryDeliveryRequest[];
}

export interface DeliveryDeliveryRequest {
  /** @uniqueItems true */
  catalog_ids: string[];
  cloud_info: DeliveryCloudInfoRequest;
  /** @uniqueItems true */
  order_item_ids: string[];
}

export interface DeliveryReadListResponse {
  deliveries?: DeliveryReadResponse[];
}

export interface DeliveryReadResponse {
  /** @example "47435e2b-d8c4-51ff-9de9-2be3bfc92276" */
  catalog_id?: string;
  cloud_delivery?: DeliveryCloudDeliveryResponse;
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3cfc92276" */
  delivery_id?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "SUCCESS" */
  status?: ConstantDeliveryStatus;
  /** @example "order_1/catalogs.zip" */
  target_path?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  task_id?: string;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
}

export interface DeliveryUpdateDeliveryRequest {
  /** @example "TRANSFER_STATUS_SUCCESS" */
  status?:
    | "TRANSFER_STATUS_UNSPECIFIED"
    | "TRANSFER_STATUS_CREATED"
    | "TRANSFER_STATUS_FAILED"
    | "TRANSFER_STATUS_IN_PROGRESS"
    | "TRANSFER_STATUS_SUCCESS";
}

export interface EntitiesErrorMetadata {
  message?: string;
  template_variables?: Record<string, any>;
  type?: ConstantErrorMetadataType;
}

export interface GeojsonFeature {
  geometry?: GeojsonFeatureGeometry;
  properties?: object;
  type?: string;
}

export interface GeojsonFeatureGeometry {
  coordinates?: number[][][];
  type?: string;
}

export interface GeojsonGeneralFeature {
  geometry?: GeojsonGeneralFeatureGeometry;
  properties?: object;
  type?: string;
}

export interface GeojsonGeneralFeatureGeometry {
  /** accepts all geojson types */
  coordinates?: any;
  type?: string;
}

export interface GeojsonGeneralGeometry {
  features?: GeojsonGeneralFeature[];
  type?: string;
}

export interface GeojsonGeometry {
  features?: GeojsonFeature[];
  type?: string;
}

export interface GithubComPixxelhqClerkApiBandsetBand {
  name: string;
  wavelength: number;
}

export interface GithubComPixxelhqClerkApiCatalogCatalogFilter {
  bandset_id?: string;
  bbox?: number[];
  collections?: string[];
  datetime?: string;
  ids?: string[];
  image_ids?: string[];
  intersects?: GithubComPixxelhqClerkApiCatalogGeometry;
  /** @default 100 */
  limit?: number;
  /** @min 0 */
  offset?: number;
  order_ids?: string[];
  order_item_ids?: string[];
  org_id?: string;
  query?: Record<string, Record<string, any>>;
  sort_by?: Record<string, ConstantSortingOrder>[];
  task_id?: string;
}

export interface GithubComPixxelhqClerkApiCatalogGeometry {
  coordinates?: number[][][];
  type?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemBand {
  name?: string;
  wavelength?: number;
}

export interface GithubComPixxelhqClerkApiOrderItemBandset {
  bands?: GithubComPixxelhqClerkApiOrderItemBand[];
  bandset_id?: string;
  custom?: number[][];
}

export interface GithubComPixxelhqClerkApiOrderItemCloudDelivery {
  config?: string;
  path?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemImage {
  geometry?: GeojsonGeometry;
  image_id?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemUIFeatures {
  recurrence?: ConstantOrderItemRecurrenceUIStatus;
}

export interface GithubComPixxelhqClerkApiOrderItemUplift {
  amount?: number;
  image_id?: string;
  percentage?: number;
  subtitle?: string;
  title?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemV2Bandset {
  bandset_id?: string;
  custom?: number[][];
}

export interface GithubComPixxelhqClerkApiOrderItemV2CloudDelivery {
  config?: string;
  path?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemV2Image {
  geometry?: GeojsonGeneralGeometry;
  image_id?: string;
}

export interface GithubComPixxelhqClerkApiOrderItemV2UIFeatures {
  recurrence?: ConstantOrderItemRecurrenceUIStatus;
}

export interface GithubComPixxelhqClerkApiOrganizationFilter {
  name: string;
  operator?: string;
  value?: any;
}

export interface GithubComPixxelhqClerkApiParameterArchiveTime {
  /** @example 30 */
  days?: number;
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 100 */
  uplift?: number;
}

export interface GithubComPixxelhqClerkApiParameterBandset {
  /** @example "36ebc432-7144-4bb8-99f9-97f2108a2b97" */
  bandset_id?: string;
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
}

export interface GithubComPixxelhqClerkApiParameterBasePrice {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 1000 */
  value?: number;
}

export interface GithubComPixxelhqClerkApiParameterCloudCover {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 5 */
  uplift?: number;
  /** @example 10 */
  value?: number;
}

export interface GithubComPixxelhqClerkApiParameterDeliverySpeed {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 0 */
  uplift?: number;
  /** @example "STANDARD" */
  value?: ConstantOrderItemDeliverySpeed;
}

export interface GithubComPixxelhqClerkApiParameterLicenseType {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example "commercial_single_entity" */
  input_type?: ConstantOrganizationType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 20 */
  uplift?: number;
}

export interface GithubComPixxelhqClerkApiParameterMinAoiSize {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 25 */
  value?: number;
}

export interface GithubComPixxelhqClerkApiParameterOffNadir {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 20 */
  uplift?: number;
  /** @example 5 */
  value?: number;
}

export interface GithubComPixxelhqClerkApiParameterTaskingType {
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  /** @example "STANDARD" */
  type?: ConstantOrderItemCaptureSpeed;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example 15 */
  uplift?: number;
}

export interface GithubComPixxelhqClerkApiParameterUIFeatures {
  /** @example true */
  is_default?: boolean;
  /** @example "Base Price" */
  title?: string;
  /** @example "The base price for the SLA parameter" */
  tooltip?: string;
}

export interface GithubComPixxelhqClerkApiPricingUplift {
  amount?: number;
  percentage?: number;
  subtitle?: string;
  title?: string;
}

export interface OrderCreateOrderWithOrderItemRequest {
  dry_run?: boolean;
  order_items: OrderItem[];
}

export interface OrderCreateRequest {
  /** @example ["['47435e2b-d8c4-41ff-9de9-2be3bfc92276']"] */
  order_item_ids: string[];
}

export interface OrderItem {
  bandset?: {
    bandset_id?: string;
  };
  /**
   * @default 20
   * @example 20
   */
  cloud_cover?: number;
  cloud_delivery?: {
    config?: string;
    path?: string;
  };
  /**
   * @default "STANDARD"
   * @example "STANDARD/EXPEDITED"
   */
  delivery_speed?: "STANDARD" | "EXPEDITED" | "";
  /** @example "2021-07-01" */
  end_date?: string;
  images: {
    geometry?: GeojsonGeneralGeometry;
    image_ids?: string[];
  }[];
  /**
   * @maxLength 100
   * @example "Order Item 1"
   */
  name?: string;
  /**
   * @max 1000
   * @example 0
   */
  no_of_occurrences?: number;
  /**
   * @default 20
   * @example 20
   */
  off_nadir?: number;
  /** @example "1234567890" */
  project_id: string;
  /**
   * @default "ONCE"
   * @example "ONCE/WEEKLY/MONTHLY/BIMONTHLY/QUARTERLY"
   */
  recurrence?: "ONCE" | "MONTHLY" | "BIMONTHLY" | "QUARTERLY" | "";
  /** @example "2021-07-01" */
  start_date?: string;
  /** @example "agriculture" */
  usecase: string;
}

export interface OrderReadListResponse {
  orders?: OrderReadResponse[];
  pagination?: ApiPaginationResponse;
}

export interface OrderReadResponse {
  /** @example "" */
  created_at?: string;
  /** @example "" */
  created_by?: string;
  /** @example 200 */
  discount_amount?: number;
  /** @example "NEW_USER" */
  discount_code?: string;
  /** @example 800 */
  final_amount?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  order_items?: OrderitemReadResponse[];
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  org_id?: string;
  /** @example "" */
  paid_at?: string;
  /** @example 200 */
  refund_amount?: number;
  /** @example "" */
  refund_at?: string;
  /** @example "PAID" */
  status?: ConstantOrderStatus;
  /** @example 1000 */
  total_amount?: number;
  /** @example "" */
  updated_at?: string;
  /** @example "" */
  updated_by?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32449bb01" */
  user_id?: string;
}

export interface OrderUpdateRequest {
  /** @example "PAYMENT_IN_PROGRESS" */
  status?: "PAID" | "REFUND" | "UNPAID" | "PAYMENT_IN_PROGRESS";
}

export interface OrderitemCreateOrderItemRequest {
  bandset?: {
    bandset_id?: string;
    custom?: number[][];
  };
  /** @example 0 */
  cloud_cover?: number;
  cloud_delivery?: {
    config?: string;
    path?: string;
  };
  /** @example "2021-07-01" */
  end_date?: string;
  images?: {
    geometry?: GeojsonGeneralGeometry;
    image_id?: string;
  }[];
  /**
   * @maxLength 100
   * @example "Order Item 1"
   */
  name?: string;
  /**
   * @max 1000
   * @example 4
   */
  no_of_occurrences?: number;
  /** @example 0 */
  off_nadir?: number;
  /** @example "1234567890" */
  project_id: string;
  /** @example "ONCE/WEEKLY/BIWEEKLY/MONTHLY/BIMONTHLY/QUARTERLY" */
  recurrence?:
    | "ONCE"
    | "WEEKLY"
    | "BIWEEKLY"
    | "MONTHLY"
    | "BIMONTHLY"
    | "QUARTERLY"
    | "NOT_APPLICABLE";
  /** @example "2021-07-01" */
  start_date?: string;
  /** @example "agriculture" */
  usecase?: string;
}

export interface OrderitemDistanceError {
  distance?: number;
  max_distance?: number;
  p0?: OrderitemDistanceErrorPoint;
  p1?: OrderitemDistanceErrorPoint;
}

export interface OrderitemDistanceErrorPoint {
  feature_index?: number;
  point?: OrderitemLatLong;
}

export interface OrderitemFilter {
  name: string;
  operator?: string;
  value?: any;
}

export interface OrderitemGeometryResponse {
  distance_errors?: OrderitemDistanceError[];
  features?: GeojsonFeature[];
  invalid_errors?: string[];
}

export interface OrderitemInternalListQuery {
  filters?: OrderitemFilter[];
  group_by?: string[];
  limit?: number;
  offset?: number;
  search?: string;
  sort?: OrderitemSort[];
}

export interface OrderitemInternalPatchRequest {
  status?: "CANCELLED" | "FAILED";
}

export interface OrderitemInterval {
  end?: string;
  start?: string;
}

export interface OrderitemLatLong {
  lat?: number;
  lon?: number;
}

export interface OrderitemPatchOrderItemRequest {
  check_feasibility?: boolean;
  id?: string;
  in_cart?: boolean;
}

export interface OrderitemReadListResponse {
  order_items?: OrderitemReadResponse[];
  pagination?: ApiPaginationResponse;
}

export interface OrderitemReadResponse {
  /** @example 1000 */
  area?: number;
  bandset?: GithubComPixxelhqClerkApiOrderItemBandset;
  /** @example 10000 */
  base_amount?: number;
  /** @example "FLEXIBLE/EXPEDITED/CRITICAL/ASSURED/NOT_APPLICABLE" */
  capture_speed?: ConstantOrderItemCaptureSpeed;
  /** @example 0 */
  cloud_cover?: number;
  cloud_delivery?: {
    config?: string;
    path?: string;
  };
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "STANDARD/EXPEDITED/NOT_APPLICABLE" */
  delivery_speed?: ConstantOrderItemDeliverySpeed;
  /** @example "2021-07-01" */
  end_date?: string;
  error_metadata?: EntitiesErrorMetadata;
  /** @example "FAILED/WEAK_SUCCESS/SUCCESS" */
  feasibility_status?: ConstantOrderItemFeasibilityStatus;
  /** @example 12000 */
  final_amount?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  images?: GithubComPixxelhqClerkApiOrderItemImage[];
  /** @example false */
  in_cart?: boolean;
  /** @example "2024-05-27T06:50:20.056549Z" */
  last_feasibility_check?: string;
  /** @example "order item 1" */
  name?: string;
  /** @example 0 */
  no_of_occurrences?: number;
  /** @example 2 */
  number_of_bands?: number;
  occurrences?: OrderitemInterval[];
  /** @example 0 */
  off_nadir?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  order_id?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  org_id?: string;
  /** @example "FULL" */
  payment_mode?: ConstantOrderItemPaymentMode;
  /** @example "PAID/PARTIAL-REFUND/REFUND/UNPAID/PARTIAL-MONTHLY" */
  payment_status?: ConstantOrderItemPaymentStatus;
  placed_at?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  project_id?: string;
  /** @example "ONCE/WEEKLY/BIWEEKLY/MONTHLY/BIMONTHLY/QUARTERLY" */
  recurrence?: ConstantOrderItemRecurrence;
  /** @example "2021-07-01" */
  start_date?: string;
  /** @example "DRAFT/ACTIVE/COMPLETED/CANCELLED/FAILED/PARTIALLY_COMPLETED" */
  status?: ConstantOrderItemStatus;
  tasks?: TaskReadResponse[];
  /** @example 100 */
  tokens_used?: number;
  /** @example "TASKING/ARCHIVE/RECURRING" */
  type?: ConstantOrderItemType;
  ui_features?: GithubComPixxelhqClerkApiOrderItemUIFeatures;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
  uplifts?: GithubComPixxelhqClerkApiOrderItemUplift[];
  /** @example "agriculture" */
  usecase?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  user_id?: string;
  validation_errors?: Record<string, string[]>[];
}

export interface OrderitemSort {
  name?: string;
  order?: string;
}

export interface OrderitemUpdateOrderItemRequest {
  bandset?: {
    bandset_id?: string;
    custom?: number[][];
  };
  /** @example 0 */
  cloud_cover?: number;
  cloud_delivery?: {
    config?: string;
    path?: string;
  };
  /** @example "STANDARD" */
  delivery_speed?: "STANDARD" | "NOT_APPLICABLE";
  /** @example "2021-07-01" */
  end_date?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  images?: {
    geometry?: GeojsonGeneralGeometry;
    image_id?: string;
  }[];
  /**
   * @maxLength 100
   * @example "Order Item 1"
   */
  name?: string;
  /**
   * @max 1000
   * @example 4
   */
  no_of_occurrences?: number;
  /** @example 0 */
  off_nadir?: number;
  /** @example "FULL" */
  payment_mode?: "FULL" | "MONTHLY";
  /** @example "1234567890" */
  project_id?: string;
  /** @example "ONCE/WEEKLY/BIWEEKLY/MONTHLY/BIMONTHLY/QUARTERLY" */
  recurrence?:
    | "ONCE"
    | "BIWEEKLY"
    | "MONTHLY"
    | "BIMONTHLY"
    | "QUARTERLY"
    | "NOT_APPLICABLE";
  /** @example "2021-07-01" */
  start_date?: string;
  ui_features?: GithubComPixxelhqClerkApiOrderItemUIFeatures;
  /** @example "agriculture" */
  usecase: string;
}

export interface OrderitemValidationRequest {
  user_geometry: GeojsonGeneralGeometry;
}

export interface OrderitemValidationResponse {
  geometry?: OrderitemGeometryResponse;
  has_errors?: boolean;
}

export interface OrganizationCreateRequest {
  /** @default "non_early" */
  adoption?: "early" | "early_binding" | "non_early";
  /** @default false */
  kyc_successful?: boolean;
  license_type?:
    | "commercial_single_entity"
    | "commercial_multi_entity"
    | "government_state_fed"
    | "government_civil"
    | "government_all_gov"
    | "government_public_access"
    | "non_commercial_free_trial"
    | "non_commercial_academic_enterprise"
    | "non_commercial_academic_trial";
  org_id: string;
}

export interface OrganizationReadListResponse {
  organizations?: OrganizationReadResponse[];
  total?: number;
}

export interface OrganizationReadResponse {
  adoption?: ConstantOrganizationAdoption;
  avatar?: string;
  created_at?: string;
  created_by?: string;
  id?: string;
  is_sandbox?: boolean;
  kyc_successful?: boolean;
  license_type?: ConstantOrganizationType;
  /** from frontier */
  name?: string;
  org_id?: string;
  state?: string;
  title?: string;
  updated_at?: string;
  updated_by?: string;
}

export interface OrganizationSearchRequest {
  filters?: GithubComPixxelhqClerkApiOrganizationFilter[];
  group_by?: string[];
  limit?: number;
  offset?: number;
  search?: string;
  sort?: OrganizationSort[];
}

export interface OrganizationSearchResponse {
  organizations?: OrganizationReadResponse[];
  pagination?: ApiPaginationResponse;
}

export interface OrganizationSort {
  name?: string;
  order?: string;
}

export interface OrganizationUpdateRequest {
  /** @default "non_early" */
  adoption?: "early" | "early_binding" | "non_early";
  /** @default false */
  kyc_successful?: boolean;
  license_type?:
    | "commercial_single_entity"
    | "commercial_multi_entity"
    | "government_state_fed"
    | "government_civil"
    | "government_all_gov"
    | "government_public_access"
    | "non_commercial_free_trial"
    | "non_commercial_academic_enterprise"
    | "non_commercial_academic_trial";
}

export interface OwnershipCreateRequest {
  /** @example "2025-08-31T10:22:33Z" */
  expiry?: string;
  /** @example "TD1_007620_20230726_L2A_20230823_03001048" */
  image_id: string;
  /** @example "7668351b-1894-450c-b31c-a7e9360b1583" */
  org_id: string;
}

export interface OwnershipIPRExclusivityRequest {
  is_ipr?: boolean;
  org_id?: string;
  s3_url?: string;
}

export interface OwnershipReadListResponse {
  ownerships?: OwnershipReadResponse[];
}

export interface OwnershipReadResponse {
  /** @example "2025-01-15T10:22:33Z" */
  created_at?: string;
  /** @example "user123" */
  created_by?: string;
  /** @example "2025-08-31T10:22:33Z" */
  expiry?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "TD1_007620_20230726_L2A_20230823_03001048" */
  image_id?: string;
  /** @example "7668351b-1894-450c-b31c-a7e9360b1583" */
  org_id?: string;
  /** @example "2025-01-15T10:22:33Z" */
  updated_at?: string;
  /** @example "user123" */
  updated_by?: string;
}

export interface ParameterCreateRequest {
  /**
   * The ID of the global parameter that you want to override
   * @example "4153c703-c141-4406-bcbc-9757b7dee899"
   */
  global_id: string;
  /**
   * Whether the parameter is enabled or not
   * @example true
   */
  is_enabled?: boolean;
  /** The UI features that are enabled for the parameter */
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /**
   * The overridden value if any for the parameter
   * @example "sample value"
   */
  value: string;
}

export interface ParameterListModel {
  parameters?: ParameterReadModel[];
}

export interface ParameterMetadata {
  /** @example "VNIR" */
  imageType?: ConstantOrderItemImageType;
  /** @example "ARCHIVE" */
  orderType?: ConstantOrderItemType;
  /** @example "L2A" */
  productType?: ConstantProductType;
}

export interface ParameterReadModel {
  aoi_size?: GithubComPixxelhqClerkApiParameterMinAoiSize;
  archive_ranges?: GithubComPixxelhqClerkApiParameterArchiveTime[];
  bandsets?: GithubComPixxelhqClerkApiParameterBandset[];
  base_price?: GithubComPixxelhqClerkApiParameterBasePrice;
  capture_types?: GithubComPixxelhqClerkApiParameterTaskingType[];
  cloud_cover_types?: GithubComPixxelhqClerkApiParameterCloudCover[];
  delivery_speeds?: GithubComPixxelhqClerkApiParameterDeliverySpeed[];
  licenses?: GithubComPixxelhqClerkApiParameterLicenseType[];
  metadata?: ParameterMetadata;
  off_nadir_types?: GithubComPixxelhqClerkApiParameterOffNadir[];
}

export interface ParameterSingleReadModel {
  /** @example "2023-10-01T12:00:00Z" */
  created_at?: string;
  /** @example "user123" */
  created_by?: string;
  /** @example "85c19850-2831-4dd8-91b1-9c3598997919" */
  global_id?: string;
  /** @example "0848dc9c-73c0-4cb5-95bd-5f3348480dfd" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  /** @example true */
  is_enabled?: boolean;
  /** @example false */
  is_overridden?: boolean;
  /** @example "OFF_NADIR" */
  name?: ConstantSLAParameter;
  /** @example "s" */
  option_name?: string;
  /** @example "ARCHIVE" */
  order_type?: ConstantOrderItemType;
  /** @example "L2A" */
  product_type?: ConstantProductType;
  ui_features?: GithubComPixxelhqClerkApiParameterUIFeatures;
  /** @example "2023-10-01T12:00:00Z" */
  updated_at?: string;
  /** @example "user123" */
  updated_by?: string;
  /** The overridden value if any for the parameter */
  value?: any;
}

export type ParameterUpdateRequest = object;

export interface PermissionCreatePermissionResponse {
  permissions?: PermissionPermission[];
}

export interface PermissionListPermissionResponse {
  permissions?: PermissionPermission[];
}

export interface PermissionPermission {
  /** @example "" */
  created_at?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id: string;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  image_id: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  org_id: string;
  /** @example "" */
  updated_at?: string;
}

export interface PricingListReadResponse {
  prices?: Record<string, PricingReadResponse>;
}

export interface PricingReadResponse {
  base_price?: number;
  total?: number;
  uplifts?: GithubComPixxelhqClerkApiPricingUplift[];
}

export interface PricingRequest {
  /** @minItems 1 */
  image_ids: string[];
}

export interface RefundsFilter {
  name: string;
  operator?: string;
  value?: any;
}

export interface RefundsInternalCreateRefundRequest {
  reason?: string;
  task_id: string;
  tokens: number;
  type:
    | "CANCELLED"
    | "EDITED"
    | "SLA_BREACHED"
    | "FAILED"
    | "PARTIALLY_FULFILLED"
    | "OTHERS";
}

export interface RefundsInternalListQuery {
  filters?: RefundsFilter[];
  group_by?: string[];
  limit?: number;
  offset?: number;
  search?: string;
  sort?: RefundsSort[];
}

export interface RefundsReadListResponse {
  pagination?: ApiPaginationResponse;
  refunds?: RefundsReadResponse[];
}

export interface RefundsReadResponse {
  created_at?: string;
  created_by?: string;
  id?: string;
  order_item_id?: string;
  org_id?: string;
  reason?: string;
  status?: string;
  task_id?: string;
  tokens?: number;
  type?: string;
  updated_at?: string;
  updated_by?: string;
}

export interface RefundsSort {
  name?: string;
  order?: string;
}

export interface StripReadListResponse {
  strips?: StripReadResponse[];
}

export interface StripReadResponse {
  /** @example "" */
  assets_url?: string;
  /** @example "" */
  created_at?: string;
  /** @example "" */
  created_by?: string;
  /** @example "2021-07-01T00:00:00Z" */
  datetime?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "TD1_xxx" */
  image_id?: string;
  /** @example "SCHEDULED" */
  status?: ConstantStripStatus;
  /** @example "" */
  strip_id?: string;
  /** @example "" */
  task_id?: string;
  /** @example "" */
  updated_at?: string;
  /** @example "" */
  updated_by?: string;
}

export interface StripUpdateStripByImageIDRequest {
  /** @example "TD1_xxx" */
  image_id: string;
  /** @example "IMAGE_STATUS_SUCCESS" */
  status:
    | "IMAGE_STATUS_SUCCESS"
    | "IMAGE_STATUS_FAILED"
    | "IMAGE_STATUS_UNSPECIFIED";
}

export interface StripUpdateStripRequest {
  /** @example "" */
  assets_url?: string;
  /** @example "TD1_xxx" */
  image_id: string;
  /** @example "STRIP_STATUS_UNSPECIFIED" */
  status:
    | "STRIP_STATUS_UNSPECIFIED"
    | "STRIP_STATUS_PENDING"
    | "STRIP_STATUS_SCHEDULED"
    | "STRIP_STATUS_CAPTURED"
    | "STRIP_STATUS_CATALOGUED"
    | "STRIP_STATUS_FAILED";
}

export interface TaskInternalPatchRequest {
  /** @example "CANCELLED" */
  status?: "CANCELLED";
}

export interface TaskReadListResponse {
  tasks?: TaskReadResponse[];
}

export interface TaskReadResponse {
  /** @example "123" */
  bandset_id?: string;
  /** @example 50 */
  cloud_cover?: number;
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "SUCCESSFUL" */
  delivery_status?: "PENDING" | "SUCCESSFUL" | "FAILED" | "NOT_APPLICABLE";
  /** @example "25-05-2024" */
  end_date?: string;
  error_metadata?: EntitiesErrorMetadata;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  gss_task_id?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example 4 */
  number_of_strips?: number;
  /** @example 10 */
  off_nadir?: number;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  order_item_id?: string;
  /** @example "15-05-2024" */
  start_date?: string;
  /** @example "FULFILLED" */
  status?: ConstantTaskResponseStatus;
  /** @example 10 */
  tokens_refunded?: number;
  /** @example 10 */
  tokens_used?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  transaction_id?: string;
  /** @example "ARCHIVE" */
  type?: ConstantTaskType;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
}

export interface TaskStripRequest {
  /** @example "37435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id: string;
}

export interface TaskUpdateReadResponse {
  /** @example "123" */
  bandset_id?: string;
  /** @example 50 */
  cloud_cover?: number;
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "SUCCESSFUL" */
  delivery_status?: "PENDING" | "SUCCESSFUL" | "FAILED" | "NOT_APPLICABLE";
  /** @example "25-05-2024" */
  end_date?: string;
  error_metadata?: EntitiesErrorMetadata;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  gss_task_id?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example 4 */
  number_of_strips?: number;
  /** @example 10 */
  off_nadir?: number;
  /** @example "TD1_006800_20230528_L2A_20230615_03001067" */
  order_item_id?: string;
  /** @example "15-05-2024" */
  start_date?: string;
  /** @example "FULFILLED" */
  status?: ConstantTaskResponseStatus;
  strips?: StripReadResponse[];
  /** @example 10 */
  tokens_refunded?: number;
  /** @example 10 */
  tokens_used?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  transaction_id?: string;
  /** @example "ARCHIVE" */
  type?: ConstantTaskType;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
}

export interface TaskUpdateRequest {
  /** @example "37435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  gss_task_id: string;
  strips: TaskStripRequest[];
}

export interface TaskUpdateTaskRequest {
  /** @example "123" */
  bandset_id: string;
  /**
   * @max 100
   * @example 50
   */
  cloud_cover: number;
  /** @example "2021-08-01T00:00:00Z" */
  end_date: string;
  /**
   * @max 100
   * @example 10
   */
  off_nadir: number;
  /** @example "2021-08-01T00:00:00Z" */
  start_date: string;
}

export interface TraceReadListResponse {
  traces?: TraceReadResponse[];
}

export interface TraceReadResponse {
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example 1 */
  id?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  resource_id?: string;
  /** @example "SCHEDULED" */
  status?: ConstantTraceStatus;
  /** @example "order_item" */
  type?: ConstantTraceType;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
}

export interface V2ReadResponse {
  /** @example 1000 */
  area?: number;
  bandset?: GithubComPixxelhqClerkApiOrderItemBandset;
  /** @example 10000 */
  base_amount?: number;
  /** @example "FLEXIBLE/EXPEDITED/CRITICAL/ASSURED/NOT_APPLICABLE" */
  capture_speed?: ConstantOrderItemCaptureSpeed;
  /** @example 0 */
  cloud_cover?: number;
  cloud_delivery?: GithubComPixxelhqClerkApiOrderItemCloudDelivery;
  /** @example "2024-05-27T06:50:20.056549Z" */
  created_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  created_by?: string;
  /** @example "STANDARD/EXPEDITED/NOT_APPLICABLE" */
  delivery_speed?: ConstantOrderItemDeliverySpeed;
  /** @example "2021-07-01" */
  end_date?: string;
  error_metadata?: EntitiesErrorMetadata;
  /** @example "FAILED/WEAK_SUCCESS/SUCCESS" */
  feasibility_status?: ConstantOrderItemFeasibilityStatus;
  /** @example 12000 */
  final_amount?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  id?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  images?: GithubComPixxelhqClerkApiOrderItemImage[];
  /** @example false */
  in_cart?: boolean;
  /** @example "2024-05-27T06:50:20.056549Z" */
  last_feasibility_check?: string;
  /** @example "order item 1" */
  name?: string;
  /** @example 0 */
  no_of_occurrences?: number;
  /** @example 2 */
  number_of_bands?: number;
  occurrences?: OrderitemInterval[];
  /** @example 0 */
  off_nadir?: number;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  order_id?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  org_id?: string;
  /** @example "FULL" */
  payment_mode?: ConstantOrderItemPaymentMode;
  /** @example "PAID/PARTIAL-REFUND/REFUND/UNPAID/PARTIAL-MONTHLY" */
  payment_status?: ConstantOrderItemPaymentStatus;
  placed_at?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  project_id?: string;
  /** @example "ONCE/WEEKLY/BIWEEKLY/MONTHLY/BIMONTHLY/QUARTERLY" */
  recurrence?: ConstantOrderItemRecurrence;
  /** @example "2021-07-01" */
  start_date?: string;
  /** @example "DRAFT/ACTIVE/COMPLETED/CANCELLED/FAILED/PARTIALLY_COMPLETED" */
  status?: ConstantOrderItemStatus;
  /** @example 100 */
  tokens_used?: number;
  /** @example "TASKING/ARCHIVE/RECURRING" */
  type?: ConstantOrderItemType;
  ui_features?: GithubComPixxelhqClerkApiOrderItemUIFeatures;
  /** @example "2024-05-27T06:50:20.056549Z" */
  updated_at?: string;
  /** @example "e31ab6f8-d359-4c6a-83c6-bfa32229bb01" */
  updated_by?: string;
  uplifts?: GithubComPixxelhqClerkApiOrderItemUplift[];
  /** @example "agriculture" */
  usecase?: string;
  /** @example "47435e2b-d8c4-41ff-9de9-2be3bfc92276" */
  user_id?: string;
  validation_errors?: Record<string, string[]>[];
}

export interface V2UpdateRequest {
  bandset?: GithubComPixxelhqClerkApiOrderItemV2Bandset;
  /** @example 0 */
  cloud_cover?: number;
  cloud_delivery?: GithubComPixxelhqClerkApiOrderItemV2CloudDelivery;
  /** @example "STANDARD" */
  delivery_speed?: "STANDARD" | "NOT_APPLICABLE";
  /** @example "2021-07-01" */
  end_date?: string;
  /** @example "VNIR" */
  image_type?: ConstantOrderItemImageType;
  images?: GithubComPixxelhqClerkApiOrderItemV2Image[];
  /**
   * @maxLength 100
   * @example "Order Item 1"
   */
  name?: string;
  /**
   * @max 1000
   * @example 4
   */
  no_of_occurrences?: number;
  /** @example 0 */
  off_nadir?: number;
  /** @example "FULL" */
  payment_mode?: "FULL" | "MONTHLY";
  /** @example "1234567890" */
  project_id?: string;
  /** @example "ONCE/WEEKLY/BIWEEKLY/MONTHLY/BIMONTHLY/QUARTERLY" */
  recurrence?:
    | "ONCE"
    | "BIWEEKLY"
    | "MONTHLY"
    | "BIMONTHLY"
    | "QUARTERLY"
    | "NOT_APPLICABLE";
  /** @example "2021-07-01" */
  start_date?: string;
  ui_features?: GithubComPixxelhqClerkApiOrderItemV2UIFeatures;
  /** @example "agriculture" */
  usecase: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Clerk API
 * @version 0.0.1
 * @contact
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags AuditLog
     * @name V1AuditLogsList
     * @summary List audit logs
     * @request GET:/api/v1/audit-logs
     */
    v1AuditLogsList: (
      query: {
        /** Comma-separated list of resource IDs */
        resource_ids: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AuditlogReadListResponse, ApiErrorResponse>({
        path: `/api/v1/audit-logs`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1BandsetsList
     * @summary List all bandsets
     * @request GET:/api/v1/bandsets
     */
    v1BandsetsList: (params: RequestParams = {}) =>
      this.request<BandsetReadListResponse, ApiErrorResponse>({
        path: `/api/v1/bandsets`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1BandsetsDetail
     * @summary Get a bandset
     * @request GET:/api/v1/bandsets/{id}
     */
    v1BandsetsDetail: (id: string, params: RequestParams = {}) =>
      this.request<BandsetReadResponse, ApiErrorResponse>({
        path: `/api/v1/bandsets/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1CatalogsDownloadsCreate
     * @summary Create a download request for a catalog
     * @request POST:/api/v1/catalogs/downloads
     */
    v1CatalogsDownloadsCreate: (
      body: CatalogDownloadRequest,
      params: RequestParams = {},
    ) =>
      this.request<CatalogDownloadResponse, ApiErrorResponse>({
        path: `/api/v1/catalogs/downloads`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1CatalogsDownloadsDetail
     * @summary Get a download request for a catalog by ID
     * @request GET:/api/v1/catalogs/downloads/{id}
     */
    v1CatalogsDownloadsDetail: (id: string, params: RequestParams = {}) =>
      this.request<CatalogDownloadResponse, ApiErrorResponse>({
        path: `/api/v1/catalogs/downloads/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1CatalogsListCreate
     * @summary List all catalogs (Used for permission checks)
     * @request POST:/api/v1/catalogs/list
     */
    v1CatalogsListCreate: (
      catalogFilter: CatalogPermissionFilter,
      params: RequestParams = {},
    ) =>
      this.request<CatalogReadListResponse, ApiErrorResponse>({
        path: `/api/v1/catalogs/list`,
        method: "POST",
        body: catalogFilter,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1CatalogsListDetailsCreate
     * @summary List all catalogs with details
     * @request POST:/api/v1/catalogs/listDetails
     */
    v1CatalogsListDetailsCreate: (
      catalogFilter: GithubComPixxelhqClerkApiCatalogCatalogFilter,
      params: RequestParams = {},
    ) =>
      this.request<CatalogReadListResponse, ApiErrorResponse>({
        path: `/api/v1/catalogs/listDetails`,
        method: "POST",
        body: catalogFilter,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1CatalogsDetail
     * @summary Get a catalog
     * @request GET:/api/v1/catalogs/{id}
     */
    v1CatalogsDetail: (id: string, params: RequestParams = {}) =>
      this.request<CatalogReadResponse, ApiErrorResponse>({
        path: `/api/v1/catalogs/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name V1DeliveriesList
     * @summary List all deliveries
     * @request GET:/api/v1/deliveries
     */
    v1DeliveriesList: (
      query?: {
        /** Delivery ID */
        delivery_id?: string;
        /** Catalog ID */
        catalog_id?: string;
        /** Task ID */
        task_id?: string;
        /** Order Item ID */
        order_item_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeliveryReadListResponse, ApiErrorResponse>({
        path: `/api/v1/deliveries`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name V1DeliveriesCreate
     * @summary Create a delivery
     * @request POST:/api/v1/deliveries
     */
    v1DeliveriesCreate: (
      body: DeliveryCreateDeliveryRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryReadListResponse, ApiErrorResponse>({
        path: `/api/v1/deliveries`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AuditLog
     * @name V1InternalAuditLogsSyncCreate
     * @summary Sync audit logs to Frontier
     * @request POST:/api/v1/internal/audit-logs/sync
     */
    v1InternalAuditLogsSyncCreate: (params: RequestParams = {}) =>
      this.request<Record<string, string>, ApiErrorResponse>({
        path: `/api/v1/internal/audit-logs/sync`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1InternalBandsetsList
     * @summary List all bandsets
     * @request GET:/api/v1/internal/bandsets
     */
    v1InternalBandsetsList: (params: RequestParams = {}) =>
      this.request<BandsetReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/bandsets`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1InternalBandsetsCreate
     * @summary Add a new bandset
     * @request POST:/api/v1/internal/bandsets
     */
    v1InternalBandsetsCreate: (
      body: BandsetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BandsetReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/bandsets`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1InternalBandsetsDetail
     * @summary Get a bandset
     * @request GET:/api/v1/internal/bandsets/{id}
     */
    v1InternalBandsetsDetail: (id: string, params: RequestParams = {}) =>
      this.request<BandsetReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/bandsets/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1InternalBandsetsUpdate
     * @summary Update a bandset
     * @request PUT:/api/v1/internal/bandsets/{id}
     */
    v1InternalBandsetsUpdate: (
      id: string,
      body: BandsetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BandsetReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/bandsets/${id}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1InternalCatalogsCreate
     * @summary Add a new catalog
     * @request POST:/api/v1/internal/catalogs
     */
    v1InternalCatalogsCreate: (
      body: CatalogCreateCatalogRequest,
      params: RequestParams = {},
    ) =>
      this.request<CatalogReadListResponse, any>({
        path: `/api/v1/internal/catalogs`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1InternalCatalogsDelete
     * @summary Delete a catalog
     * @request DELETE:/api/v1/internal/catalogs
     */
    v1InternalCatalogsDelete: (
      query: {
        /** Catalog IDs */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/internal/catalogs`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1InternalCatalogsDownloadsCreate
     * @summary Create a download request for a catalog
     * @request POST:/api/v1/internal/catalogs/downloads
     */
    v1InternalCatalogsDownloadsCreate: (
      body: CatalogDownloadRequest,
      params: RequestParams = {},
    ) =>
      this.request<CatalogDownloadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/catalogs/downloads`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1InternalCatalogsDownloadsDetail
     * @summary Get a download request for a catalog by ID
     * @request GET:/api/v1/internal/catalogs/downloads/{id}
     */
    v1InternalCatalogsDownloadsDetail: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<CatalogDownloadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/catalogs/downloads/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Catalog
     * @name V1InternalCatalogsListDetailsCreate
     * @summary List all catalogs with details
     * @request POST:/api/v1/internal/catalogs/listDetails
     */
    v1InternalCatalogsListDetailsCreate: (
      catalogFilter: GithubComPixxelhqClerkApiCatalogCatalogFilter,
      params: RequestParams = {},
    ) =>
      this.request<CatalogReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/catalogs/listDetails`,
        method: "POST",
        body: catalogFilter,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name V1InternalDeliveriesUpdate
     * @summary Update a delivery
     * @request PUT:/api/v1/internal/deliveries/{delivery_id}
     */
    v1InternalDeliveriesUpdate: (
      deliveryId: string,
      body: DeliveryUpdateDeliveryRequest,
      params: RequestParams = {},
    ) =>
      this.request<DeliveryReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/deliveries/${deliveryId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1InternalOrderItemsDelete
     * @summary Delete a orderItem
     * @request DELETE:/api/v1/internal/order-items
     */
    v1InternalOrderItemsDelete: (
      query: {
        /** OrderItem IDs */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/internal/order-items`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal-OrderItem
     * @name V1InternalOrderItemsDownloadList
     * @summary download orderitem listing
     * @request GET:/api/v1/internal/order-items/download
     */
    v1InternalOrderItemsDownloadList: (
      query?: {
        /** local timezone of the cient */
        tz?: string;
        /** local timezone of the cient */
        org_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/download`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal-OrderItem
     * @name V1InternalOrderItemsSearchCreate
     * @summary Search all orderItems
     * @request POST:/api/v1/internal/order-items/search
     */
    v1InternalOrderItemsSearchCreate: (
      body: OrderitemInternalListQuery,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/search`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1InternalOrderItemsValidateCreate
     * @summary Validate a geometry
     * @request POST:/api/v1/internal/order-items/validate
     */
    v1InternalOrderItemsValidateCreate: (
      body: OrderitemValidationRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemValidationResponse, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/validate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal-OrderItem
     * @name V1InternalOrderItemsDetail
     * @summary Get a orderItem
     * @request GET:/api/v1/internal/order-items/{id}
     */
    v1InternalOrderItemsDetail: (id: string, params: RequestParams = {}) =>
      this.request<OrderitemReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal-OrderItem
     * @name V1InternalOrderItemsUpdate
     * @summary Update a orderItem
     * @request PUT:/api/v1/internal/order-items/{id}
     */
    v1InternalOrderItemsUpdate: (
      id: string,
      body: V2UpdateRequest,
      query?: {
        /** check feasibility for the order item */
        check_feasibility?: boolean;
        /** dry run the updation of the order item */
        dry_run?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V2ReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/${id}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal-OrderItem
     * @name V1InternalOrderItemsPartialUpdate
     * @summary Patch an OrderItem
     * @request PATCH:/api/v1/internal/order-items/{id}
     */
    v1InternalOrderItemsPartialUpdate: (
      id: string,
      body: OrderitemInternalPatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/order-items/${id}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsList
     * @summary List all organizations
     * @request GET:/api/v1/internal/organizations
     */
    v1InternalOrganizationsList: (
      query?: {
        /** takes 1 as value by default */
        page_no?: number;
        /** takes 50 as value by default */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrganizationReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsCreate
     * @summary Add a new organization
     * @request POST:/api/v1/internal/organizations
     */
    v1InternalOrganizationsCreate: (
      body: OrganizationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsDownloadList
     * @summary CSV Export of organizations
     * @request GET:/api/v1/internal/organizations/download
     */
    v1InternalOrganizationsDownloadList: (params: RequestParams = {}) =>
      this.request<any, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/download`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsOnChangeWebhookCreate
     * @summary On change webhook
     * @request POST:/api/v1/internal/organizations/on-change-webhook
     */
    v1InternalOrganizationsOnChangeWebhookCreate: (
      params: RequestParams = {},
    ) =>
      this.request<OrganizationReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/on-change-webhook`,
        method: "POST",
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsRefreshList
     * @summary Update and existing organization
     * @request GET:/api/v1/internal/organizations/refresh
     */
    v1InternalOrganizationsRefreshList: (params: RequestParams = {}) =>
      this.request<OrganizationReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/refresh`,
        method: "GET",
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsSearchCreate
     * @summary Search all organizations
     * @request POST:/api/v1/internal/organizations/search
     */
    v1InternalOrganizationsSearchCreate: (
      body: OrganizationSearchRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationSearchResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/search`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsUpdate
     * @summary Update and existing organization
     * @request PUT:/api/v1/internal/organizations/{id}
     */
    v1InternalOrganizationsUpdate: (
      id: string,
      body: OrganizationUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${id}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1InternalOrganizationsDetail
     * @summary Get a organization
     * @request GET:/api/v1/internal/organizations/{org_id}
     */
    v1InternalOrganizationsDetail: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<OrganizationReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bandset
     * @name V1InternalOrganizationsBandsetsList
     * @summary List all bandsets
     * @request GET:/api/v1/internal/organizations/{org_id}/bandsets
     */
    v1InternalOrganizationsBandsetsList: (
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<BandsetReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}/bandsets`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new override parameter for a specific organization
     *
     * @tags Internal-Parameter
     * @name V1InternalOrganizationsParametersCreate
     * @summary Create a new override parameter
     * @request POST:/api/v1/internal/organizations/{org_id}/parameters
     */
    v1InternalOrganizationsParametersCreate: (
      orgId: string,
      sla_parameter: ParameterCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ParameterSingleReadModel, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}/parameters`,
        method: "POST",
        body: sla_parameter,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get an existing SLA parameter by its id
     *
     * @tags Internal-Parameter
     * @name V1InternalOrganizationsParametersDetail
     * @summary Get an existing SLA parameter
     * @request GET:/api/v1/internal/organizations/{org_id}/parameters/{id}
     */
    v1InternalOrganizationsParametersDetail: (
      id: string,
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<ParameterSingleReadModel, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}/parameters/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Update an existing SLA parameter
     *
     * @tags Internal-Parameter
     * @name V1InternalOrganizationsParametersUpdate
     * @summary Update an existing SLA parameter
     * @request PUT:/api/v1/internal/organizations/{org_id}/parameters/{id}
     */
    v1InternalOrganizationsParametersUpdate: (
      id: string,
      orgId: string,
      sla_parameter: ParameterUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ParameterSingleReadModel, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}/parameters/${id}`,
        method: "PUT",
        body: sla_parameter,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete an existing SLA parameter by its id
     *
     * @tags Internal-Parameter
     * @name V1InternalOrganizationsParametersDelete
     * @summary Delete an existing SLA parameter
     * @request DELETE:/api/v1/internal/organizations/{org_id}/parameters/{id}
     */
    v1InternalOrganizationsParametersDelete: (
      id: string,
      orgId: string,
      params: RequestParams = {},
    ) =>
      this.request<ParameterSingleReadModel, ApiErrorResponse>({
        path: `/api/v1/internal/organizations/${orgId}/parameters/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description List ownerships with optional filters. Use exclude_org_id to get image IDs from all orgs except the specified one.
     *
     * @tags Ownership
     * @name V1InternalOwnershipsList
     * @summary List ownerships with filters
     * @request GET:/api/v1/internal/ownerships
     */
    v1InternalOwnershipsList: (
      query?: {
        /** Filter by image ID */
        image_id?: string;
        /** Filter by org ID */
        org_id?: string;
        /** Exclude ownership from this org ID (useful to get images owned by other orgs) */
        exclude_org_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OwnershipReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/ownerships`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ownership
     * @name V1InternalOwnershipsCreate
     * @summary Create a new ownership
     * @request POST:/api/v1/internal/ownerships
     */
    v1InternalOwnershipsCreate: (
      body: OwnershipCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OwnershipReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/ownerships`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ownership
     * @name V1InternalOwnershipsIprExclusivityCreate
     * @summary IPR Exclusivity Ownership Creation
     * @request POST:/api/v1/internal/ownerships/ipr-exclusivity
     */
    v1InternalOwnershipsIprExclusivityCreate: (
      body: OwnershipIPRExclusivityRequest,
      params: RequestParams = {},
    ) =>
      this.request<OwnershipReadResponse, any>({
        path: `/api/v1/internal/ownerships/ipr-exclusivity`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ownership
     * @name V1InternalOwnershipsDelete
     * @summary Delete an ownership
     * @request DELETE:/api/v1/internal/ownerships/{id}
     */
    v1InternalOwnershipsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/internal/ownerships/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * @description Get a list of all global sla parameters
     *
     * @tags Parameter
     * @name V1InternalParametersList
     * @summary List global parameters
     * @request GET:/api/v1/internal/parameters
     */
    v1InternalParametersList: (params: RequestParams = {}) =>
      this.request<ParameterListModel, ApiErrorResponse>({
        path: `/api/v1/internal/parameters`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name V1InternalRefundsCreate
     * @summary Create a new refund
     * @request POST:/api/v1/internal/refunds
     */
    v1InternalRefundsCreate: (
      body: RefundsInternalCreateRefundRequest,
      params: RequestParams = {},
    ) =>
      this.request<RefundsReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/refunds`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name V1InternalRefundsSearchCreate
     * @summary List all refunds
     * @request POST:/api/v1/internal/refunds/search
     */
    v1InternalRefundsSearchCreate: (
      body: RefundsInternalListQuery,
      params: RequestParams = {},
    ) =>
      this.request<RefundsReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/refunds/search`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Refund
     * @name V1InternalRefundsRetryCreate
     * @summary Retry a failed refund
     * @request POST:/api/v1/internal/refunds/{id}/retry
     */
    v1InternalRefundsRetryCreate: (id: string, params: RequestParams = {}) =>
      this.request<RefundsReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/refunds/${id}/retry`,
        method: "POST",
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Strip
     * @name V1InternalStripsList
     * @summary List all strips
     * @request GET:/api/v1/internal/strips
     */
    v1InternalStripsList: (
      query?: {
        /** Task ID */
        task_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripReadListResponse, any>({
        path: `/api/v1/internal/strips`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Strip
     * @name V1InternalStripsUpdateByImageIdUpdate
     * @summary Update a strip by image ID
     * @request PUT:/api/v1/internal/strips/updateByImageID
     */
    v1InternalStripsUpdateByImageIdUpdate: (
      body: StripUpdateStripByImageIDRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/strips/updateByImageID`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Strip
     * @name V1InternalStripsUpdate
     * @summary Update a strip
     * @request PUT:/api/v1/internal/strips/{strip_id}
     */
    v1InternalStripsUpdate: (
      stripId: string,
      body: StripUpdateStripRequest,
      params: RequestParams = {},
    ) =>
      this.request<StripReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/strips/${stripId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksList
     * @summary List all tasks
     * @request GET:/api/v1/internal/tasks
     */
    v1InternalTasksList: (
      query?: {
        /** IDs */
        ids?: string;
        /** Order Item IDs */
        order_item_ids?: string;
        /** Type */
        type?: string;
        /** Status */
        status?: string;
        /** Start Date */
        start_date?: string;
        /** End Date */
        end_date?: string;
        /** Not Status */
        not_status?: string;
        /** GSS Task ID */
        gss_task_id?: string;
        /** GSS Task ID Is Null */
        gss_task_id_is_null?: string;
        /** Transaction ID Is Null */
        transaction_id_is_null?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksExpirePartialUpdate
     * @summary Expire tasks
     * @request PATCH:/api/v1/internal/tasks/expire
     */
    v1InternalTasksExpirePartialUpdate: (params: RequestParams = {}) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/expire`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksPaymentPendingTaskTokenDeductionCreate
     * @summary Deduct Tokens For Payment Pending Tasks
     * @request POST:/api/v1/internal/tasks/paymentPendingTaskTokenDeduction
     */
    v1InternalTasksPaymentPendingTaskTokenDeductionCreate: (
      params: RequestParams = {},
    ) =>
      this.request<TaskReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/paymentPendingTaskTokenDeduction`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksScheduleRecurringTasksCreate
     * @summary Schedule Next Recurring Task
     * @request POST:/api/v1/internal/tasks/scheduleRecurringTasks
     */
    v1InternalTasksScheduleRecurringTasksCreate: (params: RequestParams = {}) =>
      this.request<TaskReadListResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/scheduleRecurringTasks`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksSendDelayedDeliveryNotificationsCreate
     * @summary Send Delayed Delivery Notifications
     * @request POST:/api/v1/internal/tasks/sendDelayedDeliveryNotifications
     */
    v1InternalTasksSendDelayedDeliveryNotificationsCreate: (
      params: RequestParams = {},
    ) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/sendDelayedDeliveryNotifications`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksUpdateWithStripsCreate
     * @summary Update a task according to provided payload
     * @request POST:/api/v1/internal/tasks/updateWithStrips
     */
    v1InternalTasksUpdateWithStripsCreate: (
      body: TaskUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<TaskUpdateReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/updateWithStrips`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksUpdate
     * @summary Update a Task
     * @request PUT:/api/v1/internal/tasks/{id}
     */
    v1InternalTasksUpdate: (
      id: string,
      body: TaskUpdateTaskRequest,
      query?: {
        /** dry run the update of the task */
        dry_run?: boolean;
        /** check feasibility of the task */
        check_feasibility?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/${id}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksPartialUpdate
     * @summary Patch a task
     * @request PATCH:/api/v1/internal/tasks/{id}
     */
    v1InternalTasksPartialUpdate: (
      id: string,
      body: TaskInternalPatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<TaskReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/${id}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1InternalTasksRetryCreate
     * @summary Retry a failed GSS task
     * @request POST:/api/v1/internal/tasks/{id}/retry
     */
    v1InternalTasksRetryCreate: (id: string, params: RequestParams = {}) =>
      this.request<TaskReadResponse, ApiErrorResponse>({
        path: `/api/v1/internal/tasks/${id}/retry`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsList
     * @summary List all orderItems
     * @request GET:/api/v1/order-items
     */
    v1OrderItemsList: (
      query?: {
        /** User ID */
        user_id?: string;
        /** In Cart */
        in_cart?: string;
        /** Type */
        type?: string;
        /** Status */
        status?: string;
        /** Order IDs */
        order_ids?: string;
        /** IDs */
        ids?: string;
        /** Created By */
        created_by?: string;
        /** Created At Range */
        created_at?: string;
        /** Placed At Range */
        placed_at?: string;
        /** Project IDs */
        project_ids?: string;
        /** Not Status */
        not_status?: string;
        /** Error Metadata Type */
        error_metadata_type?: string;
        /** Area Range */
        area?: string;
        /** Limit */
        limit?: number;
        /** Offset */
        offset?: number;
        /** Sort By */
        sort_by?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadListResponse, ApiErrorResponse>({
        path: `/api/v1/order-items`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsCreate
     * @summary Add a new orderItem
     * @request POST:/api/v1/order-items
     */
    v1OrderItemsCreate: (
      body: OrderitemCreateOrderItemRequest,
      query?: {
        /** check feasibility for the order item */
        check_feasibility?: boolean;
        /** dry run the creation of the order item */
        dry_run?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadResponse, ApiErrorResponse>({
        path: `/api/v1/order-items`,
        method: "POST",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsDelete
     * @summary Delete a orderItem
     * @request DELETE:/api/v1/order-items
     */
    v1OrderItemsDelete: (
      query: {
        /** OrderItem IDs */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/order-items`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsDownloadList
     * @summary download orderitem listing
     * @request GET:/api/v1/order-items/download
     */
    v1OrderItemsDownloadList: (
      query?: {
        /** local timezone of the cient */
        tz?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiErrorResponse>({
        path: `/api/v1/order-items/download`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsDraftList
     * @summary List all draft orderItems for the user
     * @request GET:/api/v1/order-items/draft
     */
    v1OrderItemsDraftList: (
      query?: {
        /** In Cart */
        in_cart?: string;
        /** Limit */
        limit?: number;
        /** Offset */
        offset?: number;
        /** Sort By */
        sort_by?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadListResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/draft`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsSearchCreate
     * @summary Search all orderItems for organization
     * @request POST:/api/v1/order-items/search
     */
    v1OrderItemsSearchCreate: (
      body: OrderitemInternalListQuery,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadListResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/search`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsValidateCreate
     * @summary Validate a geometry
     * @request POST:/api/v1/order-items/validate
     */
    v1OrderItemsValidateCreate: (
      body: OrderitemValidationRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemValidationResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/validate`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsDetail
     * @summary Get a orderItem
     * @request GET:/api/v1/order-items/{id}
     */
    v1OrderItemsDetail: (id: string, params: RequestParams = {}) =>
      this.request<OrderitemReadResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsUpdate
     * @summary Update a orderItem
     * @request PUT:/api/v1/order-items/{id}
     */
    v1OrderItemsUpdate: (
      id: string,
      body: V2UpdateRequest,
      query?: {
        /** check feasibility for the order item */
        check_feasibility?: boolean;
        /** dry run the updation of the order item */
        dry_run?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<V2ReadResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/${id}`,
        method: "PUT",
        query: query,
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OrderItem
     * @name V1OrderItemsPartialUpdate
     * @summary Patch an orderItem with certain fields (in cart and feasibility supported)
     * @request PATCH:/api/v1/order-items/{id}
     */
    v1OrderItemsPartialUpdate: (
      id: string,
      body: OrderitemPatchOrderItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderitemReadResponse, ApiErrorResponse>({
        path: `/api/v1/order-items/${id}`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name V1OrdersList
     * @summary List all orders
     * @request GET:/api/v1/orders
     */
    v1OrdersList: (
      query?: {
        /** User ID */
        user_id?: string;
        /** Limit */
        limit?: number;
        /** Offset */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OrderReadListResponse, ApiErrorResponse>({
        path: `/api/v1/orders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name V1OrdersCreate
     * @summary Add a new order
     * @request POST:/api/v1/orders
     */
    v1OrdersCreate: (body: OrderCreateRequest, params: RequestParams = {}) =>
      this.request<OrderReadResponse, ApiErrorResponse>({
        path: `/api/v1/orders`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name V1OrdersExternalCreate
     * @summary Create a order with order items
     * @request POST:/api/v1/orders-external
     */
    v1OrdersExternalCreate: (
      body: OrderCreateOrderWithOrderItemRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderReadResponse, ApiErrorResponse>({
        path: `/api/v1/orders-external`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name V1OrdersDetail
     * @summary Get a order
     * @request GET:/api/v1/orders/{id}
     */
    v1OrdersDetail: (id: string, params: RequestParams = {}) =>
      this.request<OrderReadResponse, ApiErrorResponse>({
        path: `/api/v1/orders/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Order
     * @name V1OrdersUpdate
     * @summary Update a order
     * @request PUT:/api/v1/orders/{id}
     */
    v1OrdersUpdate: (
      id: string,
      body: OrderUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<OrderReadResponse, ApiErrorResponse>({
        path: `/api/v1/orders/${id}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name V1OrganizationsDetail
     * @summary Get a organization
     * @request GET:/api/v1/organizations/{org_id}
     */
    v1OrganizationsDetail: (orgId: string, params: RequestParams = {}) =>
      this.request<OrganizationReadResponse, ApiErrorResponse>({
        path: `/api/v1/organizations/${orgId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get overridden parameters for a specific organization for all product types
     *
     * @tags Parameter
     * @name V1OrganizationsParametersList
     * @summary Get All Parameters for specific organization for all product types
     * @request GET:/api/v1/organizations/{org_id}/parameters
     */
    v1OrganizationsParametersList: (
      orgId: string,
      query?: {
        /**
         * ImageType is the type of image for which the SLA parameter is applicable, comma separated values are allowed
         * @example "VNIR"
         */
        image_types?: string;
        /**
         * OrderType is the type of order for which the SLA parameter is applicable, comma separated values are allowed
         * @example "ARCHIVE,TASKING"
         */
        order_types?: string;
        /** @example "affda090-d7f2-4278-a16f-e647f9c39305" */
        org_id?: string;
        /** @example "L2A" */
        product_types?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ParameterListModel, ApiErrorResponse>({
        path: `/api/v1/organizations/${orgId}/parameters`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permission
     * @name V1PermissionsList
     * @summary List all permissions
     * @request GET:/api/v1/permissions
     */
    v1PermissionsList: (
      query?: {
        /** Org ID */
        org_id?: string;
        /** Image ID */
        image_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/permissions`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permission
     * @name V1PermissionsCreate
     * @summary Create a new permission
     * @request POST:/api/v1/permissions
     */
    v1PermissionsCreate: (
      body: PermissionPermission[],
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/permissions`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permission
     * @name V1PermissionsDelete
     * @summary Delete a permission
     * @request DELETE:/api/v1/permissions
     */
    v1PermissionsDelete: (
      query: {
        /** Permission IDs */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/permissions`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Pricing
     * @name V1PricingCreate
     * @summary pricing
     * @request POST:/api/v1/pricing
     */
    v1PricingCreate: (body: PricingRequest, params: RequestParams = {}) =>
      this.request<PricingListReadResponse, ApiErrorResponse>({
        path: `/api/v1/pricing`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Strip
     * @name V1StripsList
     * @summary List all strips
     * @request GET:/api/v1/strips
     */
    v1StripsList: (
      query?: {
        /** Task ID */
        task_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StripReadListResponse, any>({
        path: `/api/v1/strips`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1TasksList
     * @summary List all tasks
     * @request GET:/api/v1/tasks
     */
    v1TasksList: (
      query: {
        /** Order Item ID */
        order_item_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TaskReadListResponse, ApiErrorResponse>({
        path: `/api/v1/tasks`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Task
     * @name V1TasksDetail
     * @summary Get a task by ID
     * @request GET:/api/v1/tasks/{id}
     */
    v1TasksDetail: (id: string, params: RequestParams = {}) =>
      this.request<TaskReadResponse, ApiErrorResponse>({
        path: `/api/v1/tasks/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trace
     * @name V1TracesList
     * @summary List all traces
     * @request GET:/api/v1/traces
     */
    v1TracesList: (
      query?: {
        /** Resource ID */
        resource_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TraceReadListResponse, any>({
        path: `/api/v1/traces`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
